const setTitlePage = (title: string) => {
    const element = document.getElementById('titlepage');
    document.title = `AMSM - ${title}`;
    if (element) {
      element.innerText = title;
    }
}

const formatRut = (rut: string) => {
  if (rut) {
    return rut.replace(/[.-]/g, '').replace(/^(\d{1,2})(\d{3})(\d{3})(\w{1})$/, '$1.$2.$3-$4');
  }
  return '';
}

// Validar Email
const validarEmail = (email: string) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
  return re.test(String(email).toLowerCase());
}

const validarTelefono = (telefono: string) => {
  var re = /^\+569\d{8}$/;
  return re.test(telefono);
}

const formatCurrency = (number:number) => {
  return `$${new Intl.NumberFormat("de-DE").format(number)}`;
}

const isValidDate = (dateString:string) => {
  var regEx = /^\d{4}-\d{2}-\d{2}$/;
  if(!dateString.match(regEx)) return false;  // Invalid format
  var d = new Date(dateString);
  var dNum = d.getTime();
  if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
  return d.toISOString().slice(0,10) === dateString;
}

function isOnlyNumbers(cadena:string) {
  // Regex para validar números
  const numberRegex = /^[0-9]+$/;

  // Verificamos si la variable coincide con el patrón
  return numberRegex.test(cadena);
}

const dateToLocaleYears = (value:any) => {
  if(value === undefined) {
    return '';
  }
  const [date] = value.split(' ');
  let [day, month, year] = date.split('-');
  return `${year}-${month}-${day}`;
}

const capitalizeWords = (text:string) => {
  const words = text.toLocaleLowerCase().split(' ');
  const transformedWords = words.map((word:any) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
   return transformedWords.join(' ');
}

// Función para validar el RUT
const validateRut = (rut: string): boolean => {
  if (typeof rut !== 'string') {
    return false;
  }

  // Eliminar puntos y guiones del RUT
  rut = rut.replace(/[.-]/g, '');

  if (!/^[0-9]{7,8}[0-9kK]{1}$/.test(rut)) {
    return false;
  }

  const dv = rut.slice(-1).toUpperCase(); // Último dígito (verificador)
  const rutNumbers = rut.slice(0, -1); // Números del RUT

  let sum = 0;
  let multiplier = 2;

  // Calcular la suma ponderada de los dígitos del RUT en orden inverso
  for (let i = rutNumbers.length - 1; i >= 0; i--) {
    sum += parseInt(rutNumbers[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const expectedDv = 11 - (sum % 11);
  const calculatedDv = expectedDv === 11 ? '0' : expectedDv === 10 ? 'K' : String(expectedDv);

  return dv === calculatedDv;
};

export {setTitlePage, formatRut, validateRut, capitalizeWords, formatCurrency, dateToLocaleYears, isValidDate, isOnlyNumbers, validarEmail, validarTelefono};